import service from './request';
import * as util from '@/utils/index';
import axios from 'axios';
import * as Auth from '@/utils/auth';
let defaultRequest = service();
let ssoRequest = service(process.env.REFRESH_TOKEN_URL);

export function loginByUsername (data) {
  return defaultRequest({
    url: '/user/login',
    method: 'post',
    data
  });
}

export function logout () {
  return defaultRequest({
    url: '/user/logout',
    method: 'post'
  });
}

export function getUserInfo () {
  return defaultRequest({
    url: '/user/profile',
    method: 'get'
  });
}

// export function refreshToken (refreshToken) {
//   return request({
//     url: '/user/refreshToken',
//     method: 'get',
//     params: {
//       refreshToken
//     }
//   });
// }

export function resetPassword (userId) {
  let data = {
    userId
  };
  return defaultRequest({
    url: '/user/resetpassword',
    method: 'put',
    data
  });
}

export function changePassword (data) {
  return defaultRequest({
    url: '/user/changepassword',
    method: 'put',
    data
  });
}

export function forceLogin (userId) {
  let data = {
    userId
  };
  return defaultRequest({
    url: '/user/forcelogin',
    method: 'post',
    data
  });
}

export function createUser (data) {
  return defaultRequest({
    url: '/user',
    method: 'post',
    data
  });
}

export function getRoles () {
  return defaultRequest({
    url: '/role',
    method: 'get',
  });
}

export function getGroupRoles () {
  return defaultRequest({
    url: '/grouprole',
    method: 'get',
  });
}

export function setRoles (data) {
  return defaultRequest({
    url: '/user/setrole',
    method: 'put',
    data
  });
}

export function addGroupRole (data) {
  return defaultRequest({
    url: '/grouprole',
    method: 'post',
    data
  });
}

export function addRoles (data) {
  return defaultRequest({
    url: '/grouprole/addrole',
    method: 'put',
    data
  });
}

export function removeRoles (data) {
  return defaultRequest({
    url: '/grouprole/removerole',
    method: 'put',
    data
  });
}

export function refreshToken (refreshToken) {
  let data = {
    refreshToken: refreshToken,
    clientId: Auth.getClientId()
  };
  return ssoRequest({
    url: `User/refreshtoken`,
    method: 'post',
    data
  });
}

export function getUserProfile (data) {
  return ssoRequest({
    url: `User/profile?clientId=${data}`,
    method: 'get'
  });
}

export function getInternalApp () {
  return ssoRequest({
    url: `InternalApp`,
    method: 'get'
  });
}


// WEBPACK FOOTER //
// ./src/api/user.js